import { render, staticRenderFns } from "./AddTeacherModule.vue?vue&type=template&id=3739a1c9&scoped=true"
import script from "./AddTeacherModule.vue?vue&type=script&lang=js"
export * from "./AddTeacherModule.vue?vue&type=script&lang=js"
import style0 from "./AddTeacherModule.vue?vue&type=style&index=0&id=3739a1c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3739a1c9",
  null
  
)

export default component.exports